import { Loading, Modal } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { EventInviteesForm } from 'features/events/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useEventQuery } from 'features/events/queries';

type P = {
  eventId?: string;
  onCancel: () => void;
};

const ProgramEventInviteesModal = ({ eventId, onCancel }: P) => {
  const { data: eventContentObject, isLoading } = useEventQuery({ id: eventId, options: { throwOnError: false } });

  return (
    <Modal
      isOpened={Boolean(eventId)}
      maskClosable={false}
      onCancel={() => {
        onCancel();
      }}
      title="All invitees"
      width="medium"
    >
      <Modal.ScrollableContent paddingBottom={false} paddingTop={false}>
        {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases */}
        {!eventContentObject || isLoading ? <Loading /> : <EventInviteesForm eventContentObject={eventContentObject} />}
      </Modal.ScrollableContent>
    </Modal>
  );
};

export default ProgramEventInviteesModal;
